import { slideDown, slideToggle } from '../../components/utilities';

export default function setImageAccordion() {
  const sections = document.querySelectorAll('[data-image-accordion]');

  sections.forEach((section) => {
    const items = section.querySelectorAll('[data-image-accordion-item]');

    items.forEach((item) => {
      const button = item.querySelector('[data-image-accordion-button]');
      const contentWrapper = item.querySelector('[data-image-accordion-content-wrapper]');
      const content = item.querySelector('[data-image-accordion-content]');

      if (!button || !contentWrapper || !content) return;

      if (item.classList.contains('-open')) {
        slideDown(contentWrapper, content, 0);
      }

      button.addEventListener('click', () => {
        const isOpen = item.classList.toggle('-open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        slideToggle(contentWrapper, content, 300);
      });
    });
  });

  window.addEventListener('resize', () => {
    sections.forEach((section) => {
      section.querySelectorAll('[data-image-accordion-item].-open').forEach((item) => {
        const contentWrapper = item.querySelector('[data-image-accordion-content-wrapper]');
        const content = item.querySelector('[data-image-accordion-content]');

        if (contentWrapper && content) {
          slideDown(contentWrapper, content, 0);
        }
      });
    });
  });
}
